import { Box, Tab as ChakraTab, Text } from "@chakra-ui/react";

import { TabType } from ".";

type TabProps = Pick<TabType, "tab">;

const Tab = ({ tab }: TabProps) => (
  <ChakraTab
    sx={{
      svg: {
        fill: "ud-grey-600",
        transition: "fill 0.2s ease-in-out",
      },
      p: {
        color: "ud-grey-600",
        transition: "color 0.2s ease-in-out",
      },
      _hover: {
        bg: "ud-grey-dark",
        p: {
          color: "ud-white",
        },
        svg: {
          fill: "ud-white",
        },
      },
      _selected: {
        bg: "ud-black-900",
        p: {
          color: "ud-white",
        },
        svg: {
          fill: "ud-white",
        },
      },
    }}
    backgroundColor="transparent"
    transition="background-color 0.2s ease-in-out"
    flex={1}
    borderRadius="inherit"
    m="5px"
    textAlign="center"
  >
    <Box display={{ base: "none", md: "flex" }}>{tab.icon}</Box>
    <Text ml="4px" fontSize={{ base: "14px", md: "16px" }} fontWeight={500}>
      {tab.text}
    </Text>
  </ChakraTab>
);
export default Tab;
